import styled from "styled-components";
import colors from "theme/colors.module.scss";
import borders from "theme/borders.module.scss";
import spacing from "theme/spacing.module.scss";
import { Button } from "antd";
import type { ButtonProps } from "antd/lib/button";
import { StyledModal } from "../Modal/style";

export const StyledConfirmModal = styled(StyledModal)`
    width: 330px !important;
    
    .ant-modal-content {
        justify-content: space-between;
    }

    .ant-modal-footer {
        margin: 0;
        display: flex;
        justify-content: space-between;
        gap: ${spacing.spacingXS};
    }

    .ant-btn {
        border-radius: ${borders.borderRadiusSM};
    }
`;
export const StyledButton = styled(Button)<ButtonProps>`
    flex: 1;

    &:active {
        background-color: ${colors.primaryPurple100} !important;
    }
`
export const DeleteButton = styled(Button)<ButtonProps>`
    height: 40px;
    flex: 1;
`
